import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';

const RobotProfilePage = lazy(() =>
  import('@/features/robotProfile/RobotProfilePage').then((m) => ({ default: m.RobotProfilePage })),
);
const HfiDeviceProfilePage = lazy(() =>
  import('@/features/hfiDeviceProfile/HfiDeviceProfilePage').then((m) => ({
    default: m.HfiDeviceProfilePage,
  })),
);
const WaitTimeConfigPage = lazy(() =>
  import('@/features/waitTimeConfig/WaitTimeConfigPage').then((m) => ({
    default: m.WaitTimeConfigPage,
  })),
);
const ElevatorProfilePage = lazy(() =>
  import('@/features/elevatorProfile/ElevatorProfilePage').then((m) => ({
    default: m.ElevatorProfilePage,
  })),
);
const ElevatorCarProfilePage = lazy(() =>
  import('@/features/elevatorCarProfile/ElevatorCarProfilePage').then((m) => ({
    default: m.ElevatorCarProfilePage,
  })),
);
const SimStateTransitionPage = lazy(() =>
  import('@/features/simStateTransition/SimStateTransitionPage').then((m) => ({
    default: m.SimStateTransitionPage,
  })),
);
const SimRobotPage = lazy(() =>
  import('@/features/simRobot/SimRobotPage').then((m) => ({ default: m.SimRobotPage })),
);
const SimElevatorPage = lazy(() =>
  import('@/features/simElevator/SimElevatorPage').then((m) => ({ default: m.SimElevatorPage })),
);
const MqttMonitorPage = lazy(() =>
  import('@/features/mqttMonitor/public').then((m) => ({ default: m.MqttMonitorPage })),
);
const SessionListPage = lazy(() =>
  import('@/features/session/public').then((m) => ({ default: m.SessionListPage })),
);
const DashboardPage = lazy(() =>
  import('@/features/dashboard/public').then((m) => ({ default: m.DashboardPage })),
);

function PageFallback() {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', p: 6 }}>
      <CircularProgress />
    </Box>
  );
}

export function AppRoutes() {
  return (
    <Suspense fallback={<PageFallback />}>
      <Routes>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/sessions" element={<SessionListPage />} />
        <Route path="/mqtt-monitor" element={<MqttMonitorPage />} />
        <Route path="/robot-profiles" element={<RobotProfilePage />} />
        <Route path="/hfi-device-profiles" element={<HfiDeviceProfilePage />} />
        <Route path="/wait-time-config" element={<WaitTimeConfigPage />} />
        <Route path="/elevator-profiles" element={<ElevatorProfilePage />} />
        <Route path="/elevator-car-profiles" element={<ElevatorCarProfilePage />} />
        <Route path="/sim/state-transition" element={<SimStateTransitionPage />} />
        <Route path="/sim/robot" element={<SimRobotPage />} />
        <Route path="/sim/elevator" element={<SimElevatorPage />} />
        {/* Legacy path redirects (bookmarks) */}
        <Route path="/runtime/dashboard" element={<Navigate to="/dashboard" replace />} />
        <Route path="/runtime/sessions" element={<Navigate to="/sessions" replace />} />
        <Route path="/sim/monitor" element={<Navigate to="/mqtt-monitor" replace />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </Suspense>
  );
}
